import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import { textTruncate } from "src/helpers/truncateText";
import { format } from "date-fns";

export const MembersContext = createContext(null);

type Props = {
  children: ReactElement;
};

const MembersProvider: FunctionComponent<Props> = ({ children }) => {
  const [queryParams, setQueryParams] = useSearchParams();
  const pageQuery = queryParams.get("page") || 1;

  const [searchParam, setSearchParam] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const tabQuery = queryParams.get("tab");

  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["members", pageQuery],
    staleTime: 30000,
    enabled: ["members", "transaction-monitoring"].includes(tabQuery),
    queryFn: async () => {
      const url = `settings/members?page_size=10&${decodeURIComponent(
        queryParams as any,
      )}`;
      const { data } = await Api.get(`${url}`);

      const response = data.results.map(
        (res: {
          id: string;
          first_name: string;
          last_name: string;
          role: {
            name: string;
          };
          created_at: string;
          email: string;
          is_active: boolean;
        }) => ({
          id: res.id,
          name: `${
            !res.first_name?.toLowerCase() && !res.last_name?.toLowerCase()
              ? "N/A"
              : textTruncate(
                  `${res.first_name?.toLowerCase() || ""} ${
                    res.last_name?.toLowerCase() || ""
                  }`,
                  20,
                )
          }`,
          role: `${res.role?.name?.toLowerCase() || "-"}`,
          "date added": format(new Date(res.created_at), "dd/MM/yyyy"),
          "email address": res.email?.toLowerCase() || "N/A",
          status: res.is_active ? "Active" : "Inactive",
        }),
      );

      return {
        response,
        metadata: data?.metadata,
      };
    },
  });

  useEffect(() => {
    if (data) {
      // setResponse(data?.results);
      setPageCount(Math.ceil(data?.metadata.count / 10));
      // setPageCount(10);
    }
  }, [data]);

  const handleSearch = (e: any) => {
    setSearchParam(e.target.value);
  };

  const contextValue = useMemo(
    () => ({
      data,
      isLoading,
      handleSearch,
      searchParam,
      isFetching,
      // handlePaginate,
      pageNumber,
      pageCount,
      setPageNumber,
      pageQuery,
      setQueryParams,
    }),
    [
      isLoading,
      data,
      error,
      handleSearch,
      searchParam,
      isFetching,
      // handlePaginate,
      pageNumber,
      pageCount,
      setPageNumber,
      pageQuery,
      setQueryParams,
    ],
  );
  return (
    <MembersContext.Provider value={contextValue}>
      {children}
    </MembersContext.Provider>
  );
};

export default MembersProvider;
